import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import MerchantTile from 'core/modules/MerchantTile/MerchantTile';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';

import './PremierOfferTileList.scss';

function PremierOfferTileList({ placements, sectionId }) {
  return (
    <ComponentErrorBoundary>
      <div className="mn_premierOfferTileList">
        {placements.map((placement) => {
          const { id, merchant } = placement;
          return (
            <OfferOverlayLink key={id} merchantId={merchant.id} offerId={id} sectionId={sectionId}>
              <MerchantTile merchant={merchant} />
            </OfferOverlayLink>
          );
        })}
      </div>
    </ComponentErrorBoundary>
  );
}

export default PremierOfferTileList;
